import { 
  Dialog, DialogTitle, DialogContent, DialogActions,
  Typography, Button, Grid, Box, Rating, Chip
} from '@mui/material';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import SpeedIcon from '@mui/icons-material/Speed';
import AirlineSeatReclineNormalIcon from '@mui/icons-material/AirlineSeatReclineNormal';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import BatteryChargingFullIcon from '@mui/icons-material/BatteryChargingFull';

function VehicleDetailsModal({ vehicle, open, onClose }) {
  if (!vehicle) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography variant="h5">{vehicle.name}</Typography>
        <Box display="flex" alignItems="center" gap={1} mt={1}>
          <Rating value={vehicle.ratings.average} readOnly precision={0.5} />
          <Typography variant="body2">({vehicle.ratings.count} reviews)</Typography>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={3}>
          {/* Image */}
          <Grid item xs={12}>
            <img 
              src={vehicle.image} 
              alt={vehicle.name}
              style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
            />
          </Grid>

          {/* Specifications */}
          <Grid item xs={12} md={6}>
            <Typography variant="h6" gutterBottom>Specifications</Typography>
            <Box display="flex" flexDirection="column" gap={1}>
              {vehicle.type === 'electric' ? (
                <>
                  <Box display="flex" alignItems="center" gap={1}>
                    <BatteryChargingFullIcon />
                    <Typography>Range: {vehicle.specifications.range}</Typography>
                  </Box>
                  <Typography>Charging Time: {vehicle.charging.chargingTime}</Typography>
                </>
              ) : (
                <Box display="flex" alignItems="center" gap={1}>
                  <LocalGasStationIcon />
                  <Typography>Fuel Type: {vehicle.specifications.fuelType}</Typography>
                </Box>
              )}
              <Box display="flex" alignItems="center" gap={1}>
                <SpeedIcon />
                <Typography>Power: {vehicle.specifications.power}</Typography>
              </Box>
              <Box display="flex" alignItems="center" gap={1}>
                <AirlineSeatReclineNormalIcon />
                <Typography>Seats: {vehicle.specifications.seatingCapacity}</Typography>
              </Box>
            </Box>
          </Grid>

          {/* Features */}
          <Grid item xs={12} md={6}>
            <Typography variant="h6" gutterBottom>Features</Typography>
            <Box display="flex" flexWrap="wrap" gap={1}>
              {vehicle.features.map((feature, index) => (
                <Chip key={index} label={feature} />
              ))}
            </Box>
          </Grid>

          {/* Location and Insurance */}
          <Grid item xs={12}>
            <Box display="flex" alignItems="center" gap={1} mb={2}>
              <LocationOnIcon />
              <Typography>Location: {vehicle.location}</Typography>
            </Box>
            <Typography>
              Insurance: {vehicle.insurance.coverage} 
              {vehicle.insurance.included && ' (Included)'}
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button 
          variant="contained" 
          color="primary"
          onClick={() => {
            onClose();
            // Add navigation to booking page
          }}
        >
          Book Now
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default VehicleDetailsModal; 